export default "__VITE_ASSET__DZdLmQu1__"